var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYtIconRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 6") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop-HD",
    transform: "translate(-227.000000, -4366.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(227.000000, 4366.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-8",
    fill: "#C21C27",
    cx: 16,
    cy: 16,
    r: 16
  }), /*#__PURE__*/React.createElement("g", {
    id: "Shape-2",
    transform: "translate(16.001906, 16.000000) scale(1, -1) translate(-16.001906, -16.000000) translate(6.001906, 9.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6133696,0 L3.38260379,0 L3.3828184,0 C2.48501643,0 1.62413754,0.360460977 0.98946737,1.00238851 C0.354577424,1.6441105 -0.001906,2.51455462 -0.001906,3.42233206 L-0.001906,10.5778849 L-0.001906,10.5776679 C-0.001906,11.4854454 0.354593908,12.3558895 0.98946737,12.9976115 C1.62413754,13.6395557 2.48501643,14 3.3828184,14 L16.6135842,14 L16.6133696,14 C17.5111716,14 18.3720505,13.639539 19.0067206,12.9976115 C19.6416106,12.3558895 19.998094,11.4854454 19.998094,10.5776679 L19.998094,3.42211506 L19.998094,3.42233206 C19.998094,2.51455462 19.6415941,1.6441105 19.0067206,1.00238851 C18.3720505,0.36044431 17.5111716,0 16.6133696,0 L16.6133696,0 Z M13.9150736,7.136664 L7.91507514,10.247774 C7.86742735,10.2725134 7.81055319,10.2707773 7.76483342,10.2427826 C7.71890267,10.2150049 7.69078399,10.1648771 7.69035542,10.1108382 L7.69035542,3.88861833 C7.69078465,3.83458168 7.71890102,3.7844517 7.76483342,3.75667393 C7.81054935,3.72867894 7.8674268,3.72694283 7.91507514,3.7516826 L13.9150736,6.86279255 C13.9663697,6.88948532 13.9987769,6.9428703 13.9987769,7.00124806 C13.9987769,7.05962581 13.9663681,7.11300912 13.9150736,7.13970356 L13.9150736,7.136664 Z",
    id: "Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYtIconRed);
export default __webpack_public_path__ + "static/media/yt-icon--red.9f8f61ec3c635afeeae3f89e7edd5e5b.svg";
export { ForwardRef as ReactComponent };